export class MooringSiteSetupDto {
  Id: number;
  CenterPositionLat: string;
  CenterPositionLong: string;

  SiteAngleFromNorth: number;
  FleetAngleFromNorth: number;

  FleetCenterPositionLat: string;
  FleetCenterPositionLong: string;

  NWPositionLat: string;
  NWPositionLong: string;

  NEPositionLat: string;
  NEPositionLong: string;

  SEPositionLat: string;
  SEPositionLong: string;

  SWPositionLat: string;
  SWPositionLong: string;

  NoCagesWidth: number;
  NoCagesHeight: number;

  NoAnchorLines: number;
  NoBridles: number;
  // CageSize: number;
  NoFleetAnchorLines: number;

  HasServiceCorridor: boolean;
  ServiceCorridorDirection?: MooringServiceCorridorDirection;
  ServiceCorridorPlacement?: number;
  ServiceCorridorWidth?: number;

  GridLineLength: number;
  MooringDepth: number;
  ReliabilityClass: number;
  IsHorizontal: boolean; // Added IsHorizontal property
}

export type MooringServiceCorridorDirection = (typeof MooringServiceCorridorDirection)[keyof typeof MooringServiceCorridorDirection];
export const MooringServiceCorridorDirection = {
  Horizontal: 1,
  Vertical: 2,
} as const;

export class CreateMooringSiteSetupDto {
  SiteAngleFromNorth: number;
  FleetAngleFromNorth: number;

  FleetCenterPositionLat: string;
  FleetCenterPositionLong: string;

  CenterPositionLat: string;
  CenterPositionLong: string;

  NWPositionLat: string;
  NWPositionLong: string;

  NEPositionLat: string;
  NEPositionLong: string;

  SEPositionLat: string;
  SEPositionLong: string;

  SWPositionLat: string;
  SWPositionLong: string;

  NoCagesWidth: number;
  NoCagesHeight: number;
  NoAnchorLines: number;
  NoFleetAnchorLines: number;
  NoBridles: number;

  HasServiceCorridor: boolean;
  ServiceCorridorDirection?: MooringServiceCorridorDirection;
  ServiceCorridorPlacement?: number;
  ServiceCorridorWidth?: number;

  GridLineLength: number;
  MooringDepth: number;
  ReliabilityClass: number;
  IsHorizontal: boolean; // Added IsHorizontal property

  StartBuoyPosition: 'NW' | 'NE' | 'SE' | 'SW';
}
